import React from 'react';
import { motion } from 'framer-motion';
import { CadEcosystem } from './CadDrawings';

const fadeUp = {
  hidden: { opacity: 0, y: 16 },
  show: { opacity: 1, y: 0, transition: { duration: 0.55, ease: [0.22, 1, 0.36, 1] } },
};

const Hero = () => {
  const handleScrollToServices = (e) => {
    e.preventDefault();
    const element = document.querySelector('#servizi');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <section id="hero" className="cad-hero">
      <div className="cad-hero-copy">
        <motion.p
          className="cad-kicker"
          initial="hidden"
          animate="show"
          variants={fadeUp}
        >
          01 · ECOSISTEMA
        </motion.p>

        <motion.h1
          initial="hidden"
          animate="show"
          variants={fadeUp}
        >
          UN SOLO TEAM.
          <br />
          TUTTO QUELLO CHE SERVE PER PARTIRE.
        </motion.h1>

        <motion.p
          className="cad-lead"
          initial="hidden"
          animate="show"
          variants={fadeUp}
        >
          Siti e gestione, case vacanze, marketing, AI, legale e gare. Entri con un’idea o con un’attività già aperta: un interlocutore solo, dalla presenza online alla struttura del business.
        </motion.p>

        <motion.div
          initial="hidden"
          animate="show"
          variants={fadeUp}
        >
          <a
            href="#servizi"
            className="btn btn-primary"
            onClick={handleScrollToServices}
          >
            Esplora i servizi
          </a>
        </motion.div>
      </div>
      <div className="cad-hero-art">
        <CadEcosystem />
      </div>
    </section>
  );
};

export default Hero;
